
export const MyLog = {
  log: console.log.bind(window.console),
  error: console.error.bind(window.console),
};

(window as any).enableLog = (enable: boolean) => {
  if (enable) {
    MyLog.log = console.log.bind(window.console);
  } else {
    const empty = () => { };
    MyLog.log = empty;
  }
};

export const contactDeveloper = '(Entwickler kontaktieren)';

export const GridColumnStyles = {
  CELL_CLASS_INT: 'grid-int-cell',
  CELL_CLASS_STRING: 'grid-string-cell'
};

export interface PositionStyle {
  left?: number;
  bottom?: number;
  top?: number;
  right?: number;
}

export interface DimensionStyle {
  width: number;
  height: number;
}

export function splitSearchValue(value: any) {
  const vals = value.split(' ').map((v: any) => {
    return v.trim().toLowerCase();
  }).filter((v: any) => {
    return !!v;
  });
  if (vals.length > 1) {
    vals.push(value);
  }
  return vals;
}

function splitIntoNameParts(name: string) {
  const nameParts = name.replace(/-/g, ' ').split(' ').map((v: string) => {
    return v.trim();
  }).filter((v: string) => {
    return !!v;
  });
  if (nameParts.length > 0) {
    nameParts.push(name);
  };
  return nameParts;
}

export function filterCustomer(item: any, vals: string[]) {
  if (!item) {
    return false;
  }
  /*
  (item.pf || ''),
    (item.pl || ''),
    (item.plate || ''),
    (item.zip || ''),
    ('' + (item.sm || '')),
    ('' + (item.sp || '')),
    */
  let fname = (item.fname || '');
  fname = item.fns ? [fname] : splitIntoNameParts(fname);
  if (1 === fname.length) {
    item.fns = true;
  }
  let lname = (item.lname || '');
  lname = item.lns ? [lname] : splitIntoNameParts(lname);
  if (1 === lname.length) {
    item.lns = true;
  }

  const fields = ['' + item.id]
    .concat(fname, lname, [(item.city || '')]).map((v) => {
      return v.toLowerCase();
    });

  for (let t of fields) {
    for (let v of vals) {
      if (v && t.indexOf(v) === 0) {
        return true;
      }
    }
  }

  return false;
}

export function filterPartner(item: any, vals: string[]) {
  if (!item) {
    return false;
  }

  let fname = (item.fname || '');
  fname = item.fns ? [fname] : splitIntoNameParts(fname);
  if (1 === fname.length) {
    item.fns = true;
  }
  let lname = (item.lname || '');
  lname = item.lns ? [lname] : splitIntoNameParts(lname);
  if (1 === lname.length) {
    item.lns = true;
  }

  const fields = [
    '' + item.id,
    ('' + (item.sm || '')),
    ('' + (item.sp || ''))].concat(
      fname,
      lname,
      [
        (item.zip || ''),
        (item.city || '')
      ]
    ).map((v) => {
      return v.toLowerCase();
    });

  for (let t of fields) {
    for (let v of vals) {
      if (v && t.indexOf(v) === 0) {
        return true;
      }
    }
  }

  return false;
}

const phoneRegExp = /\(\)\-\+\s/g;

export function setRawPhones(item: any) {
  if (item) {
    if (item.mobile) {
      item.sm = ('' + item.mobile).replace(phoneRegExp, '');
    }
    if (item.phone) {
      item.sp = ('' + item.phone).replace(phoneRegExp, '');
    }
  }
}
